<template>
  <a-card :loading="loading">
    <div slot="title">
      <a-icon type="pic-center" />
      <span>&nbsp; {{page=='cashOnBank' ? 'Cash On Bank Manifest' : 'Cash On Hand Manifest'}}</span>
    </div>
    <a-row :gutter="24" v-if="page=='cashOnBank'">
      <a-col :xs="{ span: 24 }" :lg="{ span: 24 }">
        <ul class="m-list-wrapper bordered">
          <li>
            <span class="m-list-title" for>Bank</span>
            <span class="m-list-desc">
              <div style="display:flex;align-items: center;">
                <img :src="urllogo+'assets/bank/'+
                  (datasource.header.length>0 ? datasource.header[0].logo_bank :'#')" style="max-width:100px"
                v-bind:onerror="'this.src='+urllogonotfound"
                >
              &nbsp;
              {{ datasource.header.length>0 ? 
              datasource.header[0].nama_bank
              : "-" }}
              {{datasource.header.length>0 ? datasource.header[0].kode_bank : "-"}}
              | {{ datasource.header.length>0 ?  datasource.header[0].currency : "-" }}
              </div>
            </span>
          </li>
          <li>
            <span class="m-list-title" for>Owner</span>
            <span class="m-list-desc">{{datasource.header.length>0 ? 
              (datasource.header[0].pemilik ? datasource.header[0].pemilik : "-")  
              : "-" }} ({{datasource.header.length>0 ? datasource.header[0].kode_rekening : "-"}})</span>
          </li>
          <li>
            <span class="m-list-title" for>Created By</span>
            <span class="m-list-desc">{{datasource.header.length>0 ? 
              (datasource.header[0].tlc_create ? datasource.header[0].tlc_create : "-")  
              : "-" }}</span>
          </li>
          <li>
            <a-collapse class="margin-top" activeKey="1">
              <a-collapse-panel key="1">
              <h4 slot="header" class="margin-remove">Details</h4>
              <a-row :gutter="24">
                <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
                  <a-month-picker
                    v-model="selectDt"
                    placeholder="Select Periode"
                    @change="changeDtlDt"
                    :format="'MM-YYYY'"
                  />
                </a-col>
                <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
                  <a-input-search
                    v-model="search"
                    placeholder="Quick Search"
                    allowClear
                    @change="searching"
                    class="margin-bottom"
                  />
                </a-col>
              </a-row>
              <a-table
                :columns="columns"
                :dataSource="datasource.dtl"
                :pagination="pagination"
                :loading="loadingTable"
                size="small"
                bordered
                :rowKey="(record, index) => {return index;}"
                :scroll="{ x: 950 }"
              >
                <a
                  v-if="item.jenis_transaksi!='Rekonsiliasi' 
                    && item.jenis_transaksi!='Garansi'"
                  slot="transaksi"
                  slot-scope="item"
                  @click="handleLinkTransaction(item.jenis_transaksi, item.id, null)"
                  >{{ item.no_transaksi }}</a
                >
                <span slot="transaksi" slot-scope="item"
                  v-else>
                  {{ item.no_transaksi }}
                </span>
                <span slot="debit" slot-scope="debit">
                  <CurrencyJustified
                    v-if="debit"
                    :currencyValue="datasource.header[0].currency"
                    :valueNumber="debit"
                  />
                  <div v-else style="text-align: center; width: 100%">-</div>
                </span>
                <span slot="kredit" slot-scope="kredit">
                  <CurrencyJustified
                    v-if="kredit"
                    :currencyValue="datasource.header[0].currency"
                    :valueNumber="kredit"
                  />
                  <div v-else style="text-align: center; width: 100%">-</div>
                </span>
                <div slot="footer" class="padding-all">
                  <a-row type="flex">
                    <a-col :span="7" :order="1" class="m-text-align left"
                      >Saldo Awal Bulan {{selectedMonth}}</a-col>
                    <a-col
                      :span="7"
                      :order="2"
                      class="m-text-align left m-text-bold"
                    >
                      <CurrencyJustified
                        :currencyValue="datasource.header[0].currency"
                        :valueNumber="datasource.saldo_awal"
                      />
                    </a-col>
                  </a-row>
                  <a-row type="flex">
                    <a-col :span="7" :order="1" class="m-text-align left"
                      >Total Debit Bulan {{selectedMonth}}</a-col>
                    <a-col
                      :span="7"
                      :order="2"
                      class="m-text-align left m-text-bold"
                    >
                      <CurrencyJustified
                        :currencyValue="datasource.header[0].currency"
                        :valueNumber="datasource.debit"
                      />
                    </a-col>
                  </a-row>
                  <a-row type="flex">
                    <a-col :span="7" :order="1" class="m-text-align left"
                      >Total Credit Bulan {{selectedMonth}}</a-col>
                    <a-col
                      :span="7"
                      :order="2"
                      class="m-text-align left m-text-bold"
                    >
                      <CurrencyJustified
                        :currencyValue="datasource.header[0].currency"
                        :valueNumber="datasource.kredit"
                      />
                    </a-col>
                  </a-row>
                  <a-row type="flex">
                    &nbsp;
                  </a-row>
                  <a-row type="flex">
                    <a-col :span="7" :order="1" class="m-text-align left"
                      ><b>Saldo Bulan {{selectedMonth}}</b></a-col>
                    <a-col
                      :span="7"
                      :order="2"
                      class="m-text-align left m-text-bold"
                    >
                      <CurrencyJustified
                        :currencyValue="datasource.header[0].currency"
                        :valueNumber="datasource.saldo"
                      />
                    </a-col>
                  </a-row>
                  <a-row type="flex">
                    <a-col :span="7" :order="1" class="m-text-align left"
                      ><b>Saldo Efektif {{selectedMonth}}</b></a-col>
                    <a-col
                      :span="7"
                      :order="2"
                      class="m-text-align left m-text-bold"
                    >
                      <CurrencyJustified
                        :currencyValue="datasource.header[0].currency"
                        :valueNumber="datasource.saldo_efektif"
                      />
                    </a-col>
                  </a-row>
                  <a-row type="flex">
                    <a-col :span="7" :order="1" class="m-text-align left"
                      ><b>Dana Blokir {{selectedMonth}}</b></a-col>
                    <a-col
                      :span="7"
                      :order="2"
                      class="m-text-align left m-text-bold"
                    >
                      <CurrencyJustified
                        :currencyValue="datasource.header[0].currency"
                        :valueNumber="datasource.saldo_blokir"
                      />
                    </a-col>
                  </a-row>
                </div>
              </a-table>
              </a-collapse-panel>
            </a-collapse>
          </li>
        </ul>
      </a-col>
    </a-row>
    <a-row :gutter="24" v-if="page=='cashOnHand'">
      <a-col :xs="{ span: 24 }" :lg="{ span: 24 }">
        <ul class="m-list-wrapper bordered">
          <li>
            <span class="m-list-title" for>Bank Account</span>
            <span class="m-list-desc">
              <div class="m-display-flex flex-row space-between width-full"
                style="place-content: flex-start;align-items: center;">
                <div class="photos-wrapper">
                <img :src="
                  (datasource.header.length>0 ? datasource.header[0].foto_karyawan :'#')"
                
                >
                </div>
                <div>
                &nbsp;
                {{ datasource.header.length>0 ? 
                datasource.header[0].pic_kas_kecil
                : "-" }}
                {{ datasource.header.length>0 ? 
                "(" +datasource.header[0].tlc +")"
                : "" }}
                </div>
              </div>
            </span>
          </li>
          <li>
            <span class="m-list-title" for>Quota</span>
            <span class="m-list-desc">{{datasource.header.length>0 ? 
              formatCurrency(datasource.header[0].currency, datasource.header[0].quota) : "-" }}</span>
          </li>
          <li>
            <span class="m-list-title" for>Usage</span>
            <span class="m-list-desc">{{datasource.header.length>0 ? 
              formatCurrency(datasource.header[0].currency, datasource.header[0].pemakaian) : "-" }}</span>
          </li>
          <li>
            <span class="m-list-title" for>Balance</span>
            <span class="m-list-desc">{{datasource.header.length>0 ? 
              formatCurrency(datasource.header[0].currency, datasource.header[0].saldo) : "-" }}</span>
          </li>
          <li>
            <a-collapse class="margin-top" activeKey="1">
              <a-collapse-panel key="1">
              <h4 slot="header" class="margin-remove">Details</h4>
              <a-row :gutter="24">
                <a-col :xs="{ span: 24 }" :lg="{ span: 24 }">
                  <a-input-search
                    v-model="search"
                    placeholder="Quick Search"
                    allowClear
                    @change="searching"
                    class="margin-bottom"
                  />
                </a-col>
              </a-row>
              <a-table
                :columns="columns"
                :dataSource="datasource.dtl"
                :pagination="pagination"
                :loading="loadingTable"
                size="small"
                bordered
                :rowKey="(record, index) => {return index;}"
                :scroll="{ x: 500}"
              >
                <a
                  slot="transaksi"
                  slot-scope="item"
                  @click="handleLinkTransaction('kas_kecil', item.id_kas,item.tlc)"
                  >{{ item.no_transaksi }}</a
                >
                <span slot="debit" slot-scope="debit">
                  <CurrencyJustified
                    v-if="debit"
                    :currencyValue="datasource.header[0].currency"
                    :valueNumber="debit"
                  />
                  <div v-else style="text-align: center; width: 100%">-</div>
                </span>
                <span slot="kredit" slot-scope="kredit">
                  <CurrencyJustified
                    v-if="kredit"
                    :currencyValue="datasource.header[0].currency"
                    :valueNumber="kredit"
                  />
                  <div v-else style="text-align: center; width: 100%">-</div>
                </span>
                <div slot="footer" class="padding-all">
                  <a-row type="flex">
                    <a-col :span="7" :order="1" class="m-text-align left"
                      >Total Debit</a-col>
                    <a-col
                      :span="7"
                      :order="2"
                      class="m-text-align left m-text-bold"
                    >
                      <CurrencyJustified
                        :currencyValue="datasource.header[0].currency"
                        :valueNumber="datasource.header.length>0 ? datasource.header[0].quota :0"
                      />
                    </a-col>
                  </a-row>
                  <a-row type="flex">
                    <a-col :span="7" :order="1" class="m-text-align left"
                      >Total Credit</a-col>
                    <a-col
                      :span="7"
                      :order="2"
                      class="m-text-align left m-text-bold"
                    >
                      <CurrencyJustified
                        :currencyValue="datasource.header[0].currency"
                        :valueNumber="datasource.header.length>0 ? datasource.header[0].pemakaian : 0"
                      />
                    </a-col>
                  </a-row>
                  <br/>
                  <a-divider class="margin-small" />
                  <a-row type="flex">
                    &nbsp;
                  </a-row>
                  <a-row type="flex">
                    <a-col :span="7" :order="1" class="m-text-align left"
                      ><b>Remaining Balance</b></a-col>
                    <a-col
                      :span="7"
                      :order="2"
                      class="m-text-align left m-text-bold"
                    >
                      <CurrencyJustified
                        :currencyValue="datasource.header[0].currency"
                        :valueNumber="datasource.header.length>0 ? datasource.header[0].saldo : 0"
                      />
                    </a-col>
                  </a-row>
                </div>
              </a-table>
              </a-collapse-panel>
            </a-collapse>
          </li>
        </ul>
      </a-col>
    </a-row>
  </a-card>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import dueDateCalc from "@/mixins/dueDateCalc.js";
import Status from "@/components/Status.vue";
import HandleRoute from "@/mixins/HandleRoute";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import _ from "lodash";

export default {
  name: "manifest-ap",
  component: { Status },
  data() {
    return {
      page: this.$attrs.pages,
      datasource: {
        header:{
          quota:0
        },
        dtl:[],
      }, 
      detil_origin:[],
      loading: false,
      loadingTable: false,
      urllogo: this.$serviceUrl,
      urllogonotfound: '"'+this.$serviceUrl+'assets/bank/not-found.png"',
      search: undefined,
      selectDt: undefined,
      pagination: {
        onChange: (page) => {},
        pageSize: 10,
        size: "small",
      },
     };
  },
  mixins: [dueDateCalc, HandleRoute, CurrencyFormat],
  created() {
    this.fetch();
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getDefaultDateFormat",
      "getAuth",
      "getDateTimeFormat",
    ]),
    columns() {
      let { sortedInfo, filteredInfo } = this;
      sortedInfo = sortedInfo || {};
      filteredInfo = filteredInfo || {};
      const kolom = this.page=='cashOnBank' ? [
            {
              title: "Date",
              dataIndex: "tanggal",
              width: 100,
              key: "tanggal",
              align: "center",
              sorter: (a, b) =>
                new Date(
                  moment(a.tanggal, this.getDefaultDateFormat).format(
                    this.getStandartFormatDate
                  )
                ) -
                new Date(
                  moment(b.tanggal, this.getDefaultDateFormat).format(
                    this.getStandartFormatDate
                  )
                ),
              // fixed: "left",
            },
            {
              title: "Transaction Number",
              scopedSlots: { customRender: "transaksi" },
              key: "transaksi",
              width: 170,
              sorter: (a, b) => a.no_transaksi.length - b.no_transaksi.length,
            },
            {
              title: "Transaction Type",
              dataIndex: "jenis_transaksi",
              key: "jenis_transaksi",
              width: 150,
              sorter: (a, b) => a.jenis_transaksi.length - b.jenis_transaksi.length,
            },
            {
              title: "Description",
              dataIndex: "deskripsi",
              key: "deskripsi",
              width: 350,
              sorter: (a, b) => a.jenis_transaksi.length - b.jenis_transaksi.length,
            },
            {
              title: "Debit",
              dataIndex: "debit",
              key: "debit",
              width: 200,
              sorter: (a, b) => a.debit.val.length - b.debit.val.length,
              // fixed: "right",
              scopedSlots: { customRender: "debit" },
            },
            {
              title: "Credit",
              dataIndex: "kredit",
              key: "kredit",
              width: 200,
              sorter: (a, b) => a.kredit.val.length - b.kredit.val.length,
              // fixed: "right",
              scopedSlots: { customRender: "kredit" },
            },
          ] : [
            {
              title: "Date",
              dataIndex: "tanggal",
              width: 150,
              key: "tanggal",
              align: "center",
              sorter: (a, b) =>
                new Date(
                  moment(a.tanggal, this.getDefaultDateFormat).format(
                    this.getStandartFormatDate
                  )
                ) -
                new Date(
                  moment(b.tanggal, this.getDefaultDateFormat).format(
                    this.getStandartFormatDate
                  )
                ),
              // fixed: "left",
            },
            {
              title: "Transaction Number",
              scopedSlots: { customRender: "transaksi" },
              key: "transaksi",
              sorter: (a, b) => a.no_transaksi.length - b.no_transaksi.length,
            },
            {
              title: "Credit",
              dataIndex: "kredit",
              key: "kredit",
              width: 250,
              sorter: (a, b) => a.kredit.val.length - b.kredit.val.length,
              // fixed: "right",
              scopedSlots: { customRender: "kredit" },
            },
          ];
      return kolom;
    },
    selectedMonth(){
      let result = moment().format('MMMM YYYY');
        if(this.selectDt){
          result = moment(this.selectDt).format('MMMM YYYY');
        }
      return result
    }
  },
  methods: {
    moment,
    fetch() {
      if(this.page=='cashOnBank'){
      let period = this.moment().format("YYYY-MM-DD");
      this.loading = true;
      this.$store
        .dispatch("getManifestCashonbank", { kode_bank:this.$attrs.id, periode:period })
        .then((res) => {
          this.datasource = res;
          this.detil_origin = res.dtl;
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          let responses = Object.assign({}, error);
          if (responses.response.data) {
            this.displayMessageValue(
              "error-other",
              responses.response.data.message
            );
          } else {
            this.displayMessageValue("error-other", responses.response);
          }
        });
      }else if (this.page=='cashOnHand'){
        this.loading = true;
        this.$store
        .dispatch("getManifestCashonhand", { 
          pic_kas_kecil: this.$attrs.id 
        })
        .then((res) => {
          this.datasource = res;
          this.detil_origin = res.dtl;
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          let responses = Object.assign({}, error);
          if (responses.response.data) {
            this.displayMessageValue(
              "error-other",
              responses.response.data.message
            );
          } else {
            this.displayMessageValue("error-other", responses.response);
          }
        });
      }
    },
    changeDtlDt(){
      this.loadingTable=true;
        let period = this.selectDt ? this.moment(this.selectDt).format("YYYY-MM-DD")
                     :moment().format("YYYY-MM-DD");
        this.$store
          .dispatch("getManifestCashonbank", { kode_bank:this.$attrs.id, periode:period })
          .then((res) => {
            this.datasource = res;
            this.detil_origin = res.dtl;
            this.loadingTable=false;
        })
        .catch((error) => {
          this.loadingTable=false;
          let responses = Object.assign({}, error);
          if (responses.response.data) {
            this.displayMessageValue(
              "error-other",
              responses.response.data.message
            );
          } else {
            this.displayMessageValue("error-other", responses.response);
          }
        });
    },
    searching() {
      if(this.search){
        if (this.page=="cashOnBank"){
          this.datasource.dtl = _.filter(
            this.detil_origin,
            (value) =>
              (value.tanggal ? value.tanggal : "")
                .toLowerCase()
                .indexOf(this.search.toLowerCase()) >= 0 ||
              (value.no_transaksi ? value.no_transaksi : "")
                .toLowerCase()
                .indexOf(this.search.toLowerCase()) >= 0 ||
              (value.jenis_transaksi ? value.jenis_transaksi : "")
                .toLowerCase()
                .indexOf(this.search.toLowerCase()) >= 0 ||
              (value.deskripsi ? value.deskripsi : "")
                .toLowerCase()
                .indexOf(
                this.search.toLowerCase()
              ) >= 0 
          );
        }else{
          this.datasource.dtl = _.filter(
            this.detil_origin,
            (value) =>
              (value.tanggal ? value.tanggal : "")
                .toLowerCase()
                .indexOf(this.search.toLowerCase()) >= 0 ||
              (value.no_transaksi ? value.no_transaksi : "")
                .toLowerCase()
                .indexOf(this.search.toLowerCase()) >= 0 ||
              (value.jenis_transaksi ? value.jenis_transaksi : "")
                .toLowerCase()
                .indexOf(this.search.toLowerCase()) >= 0 ||
              (value.deskripsi ? value.deskripsi : "")
                .toLowerCase()
                .indexOf(
                this.search.toLowerCase()
              ) >= 0 
          );
        }
      }else{
        this.datasource.dtl = this.detil_origin;
      }
      return true;
    },
    handleLinkTransaction(jenis,id_,tlc_){
      let manifest = null;
      if (jenis == "kas_kecil") {
        manifest = "manifestLaporanKasKecilKeu";
      } else if (jenis == "BKK") {
        manifest = "bkkManifestKeu";
      } else if (jenis == "Garansi") {
        manifest = "bankguarantee-manifest";
      } else if (jenis == "BKM") {
        manifest = "bkmManifestKeu";
      } 
      // else if (jenis == "Rekonsiliasi") {
      //   manifest = "reconciliation-manifestKeu";
      // } 
      if (manifest)
        this.$router.push({ name: manifest, params: { tlc:tlc_,id: id_ } });
    }
  },
};
</script>

<style scoped lang="less">
.photos {
  &-wrapper {
    width: 64px;
    height: 86px;
    position: relative;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid white;
    // border-radius: 12px;
    margin-top:5px;
    img {
      width: 100%;
      align-self: flex-start;
    }
  }
}
</style>
